
  // VUE相关
  import {Component, Ref, Vue, Watch} from "vue-property-decorator";
  import enumFilter from "@/mixins/filters/enums";
  import AgileAuditTag from "@/components/AgileAuditTag/index.vue";
  // 接口和DTO
  import api from "@/api/index"; //ABP API接口
  import {AuditUserLogType, PaymentCategoryScope, ProjectDto, ReimbursementDto} from "@/api/appService";
  // 自定义组件
  import EditReimbursement from "./components/edit-reimbursement.vue";
  import OrganizationUnitQuerySelect from "@/components/OrganizationUnitQuerySelect/index.vue";
  import PagedTableView from "@/components/PagedTableView/index.vue";
  import FillVoucherNumber from "@/views/pays/components/FillVoucherNumber.vue";
  // vuex
  import ReimbursementDetail from "@/views/pays/components/detail-reimbursement.vue";
  import ExcelExport from "@/components/ExcelExport/index.vue";
  import ExportButton from "@/components/ExportButton/index.vue";
  import PaymentCategorySelect from "@/components/PaymentCategorySelect/index.vue";
  import AuditFlowDetailButton from "@/components/AuditFlowDetailButton/index.vue";
  import {Route, RouteConfig} from "vue-router";
  import AuditFilterSelect from "@/components/AuditFilterSelect/index.vue";

  @Component({
    name: "ReimbursementList",
    components: {
      AuditFilterSelect,
      AuditFlowDetailButton,
      PaymentCategorySelect,
      ExportButton,
      ExcelExport,
      ReimbursementDetail,
      EditReimbursement,
      AgileAuditTag,
      FillVoucherNumber,
      OrganizationUnitQuerySelect: OrganizationUnitQuerySelect,
      PagedTableView
    },
    mixins: [enumFilter]
  })
  export default class ReimbursementToOrg extends Vue {
    @Ref() editForm!: EditReimbursement;

    // 原data start
    tableItems: ReimbursementDto[] = [];
    private currentDetail:ReimbursementDto = {};

    private categoryList = {};


    queryForm: any = {
      amount: undefined,
      amountStart: undefined,
      amountEnd: undefined,
      requestDateStart: '',
      requestDateEnd: '',
      organizationUnitId: undefined,
      audit: undefined,
      voucherNumber: undefined,
      type:'org',
      projectId:undefined,
      auditFilterType:undefined
    };

    // 原data end

    async created() {
      this.queryForm.type = 'org';
      await this.fetchCategories();
    }



    fetchData(params: any) {
      params.type = 'org';
      return api.reimbursement.getAll(params);
    }

    get scopeFilter(){
      return PaymentCategoryScope.Reimbursement;
    }

    get hostType(){
      return AuditUserLogType.Reimbursement;
    }

    ///获取所有分类
    async fetchCategories() {
      await api.paymentCategoryService.getCategoryList().then(res => {
        this.categoryList = res;
      });
    }


    // 新建
    handleCreate() {
      (this.$refs.editForm as any).show = true;
    }

    // 编辑
    handleEdit(index: number, row: any) {
      (this.$refs.editForm as any).form = row;
      (this.$refs.editForm as any).show = true;

    }

    handleViewDetail(row:ReimbursementDto){
      this.currentDetail = row;
      (this.$refs.reimbursementDetail as any).show = true;
    }

    // 删除
    async handleDelete(index: number, row: ReimbursementDto) {
      this.$confirm("你确定删除吗?", "提示").then(async () => {
        await api.reimbursement.delete({id: row.id}).then(res => {
          this.$message({
            type: "success",
            message: "删除成功!"
          });
        });
      });
    }

    // 填写凭证号
    handleFillVoucherNumber(index: number, row: ReimbursementDto){
      (this.$refs.fillVoucherNumber as any).id = row.id;
      (this.$refs.fillVoucherNumber as any).show = true;
    }


    //  提交审核
    async handleStartAudit(item: ReimbursementDto) {
      await api.reimbursement.startAudit({body: item}).then(res => {
        this.$message.success("已提交");
      });
    }
  }
